import React, { FC } from 'react'

import { IconInterchangeableBatteriesProps } from './IconInterchangeableBatteries.types'
import * as Styled from './styles/IconInterchangeableBatteries.style'

import { nonThemeableRules } from '../../ruleSet'

const IconInterchangeableBatteries: FC<IconInterchangeableBatteriesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconInterchangeableBatteriesProps['size'],
  isResponsive = false,
}: IconInterchangeableBatteriesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M26.266 39.05h7.87c2.208 0 4-1.792 4-4V9.075H25.673a3.55 3.55 0 0 0-3.55 3.551'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M25.559 9.074V6.91a1.77 1.77 0 0 1 1.773-1.777h5.27a1.778 1.778 0 0 1 1.773 1.777v2.164'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M25.879 27.04V13.112H13.418a3.557 3.557 0 0 0-3.555 3.551V39.05c0 2.207 1.793 4 4 4h8.016a4 4 0 0 0 4-4v-2.989'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M13.3 13v-2.102c0-.98.798-1.777 1.778-1.777h5.266a1.778 1.778 0 0 1 1.777 1.777V13'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M32.055 25.082a6.526 6.526 0 1 1-13.051 0v-2.984'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='m22.055 25.156-3.051-3.058-3.012 3.011' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconInterchangeableBatteries
